import get from 'lodash/get';

import { Action, Topic, TopicLink } from 'types';

export interface TopicReducer {
  topicLinksInArray: TopicLink[];
  topicsBySlug: {
    [slug: string]: Topic;
  };
}

const initialState: TopicReducer = {
  topicLinksInArray: [],
  topicsBySlug: {},
};

export default (
  state: TopicReducer = initialState,
  action: Action
): TopicReducer => {
  switch (action.type) {
    case 'FETCH_ARTICLE_OR_TOPIC_FULFILLED':
      if (get(action, 'payload.type') === 'topic') {
        if (!action.payload) return state;

        return {
          ...state,
          topicsBySlug: {
            ...state.topicsBySlug,
            [action.payload.slug]: action.payload as Topic,
          },
        };
      }

      return state;

    case 'FETCH_TOPIC_LINKS_FULFILLED':
      return {
        ...state,
        topicLinksInArray: action.payload,
      };
    default:
      return state;
  }
};
